<template>
    <div>
        <BreadCrumb :data="breadCrumb"  />
          <b-card class="formGroup">
            <TicketForm ref="TicketForm" @save="saveForm"/>
        </b-card>
    </div>
</template>

<script>
    import TicketForm from './components/TicketForm'
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';

    let breadCrumb = [
        { label: i18n.t('pages.ticket.name'), url: "/Ticket/List" },
        { label: i18n.t('pages.ticket.add'), url: "/Ticket/Add" },
    ]

    
    export default {
        name: 'TicketAdd',
        
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Ticket",
                modalName: "",                
            }
        },
        components:{
            BreadCrumb,TicketForm
        },
        computed: {
            isLoading() {
                return this.$store.getters.getTicketLoading
            }
        },
        methods:{
            /* Modalı açan event */
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            /* Componentlerin içerisinden hangi modalın açıldığı ile ilgili event  */
            pageSettings: function(state, form){
                this.newButton = state
                this.currentForm = form
            },
            saveForm() {
                this.$refs.TicketForm.$refs.TicketForm.validate().then( async success =>{
                    if(success){
                        let data = {
                            title: this.$refs.TicketForm.title,
                            customer: this.$refs.TicketForm.customer.ID,
                            customer_product: this.$refs.TicketForm.customerProduct ? 
                                this.$refs.TicketForm.customerProduct.product.id : null,
                            customer_sub: this.$refs.TicketForm.customer_sub ? 
                                this.$refs.TicketForm.customer_sub.id : null,
                            ticketInfo: {
                                comment: this.$refs.TicketForm.ticketInfo.comment
                            },
                            status_id: 1
                        }
                        await this.$store.dispatch('addTicket', data)

                        if(this.$store.getters.getTicketStatus == "Success"){
                            this.$router.push('/Ticket/List')
                        }
                    }
                })  
            }
        },
    }
</script>

<style lang="css" scoped > 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/Add.vue